import React, { useState } from "react";
import { Box, Button, Flex, Stack, useTheme } from "@chakra-ui/react";
import DataQuality from "./components/DataQuality";
import CsvValidator from "./components/CsvValidator";

const Validation = () => {
  const [activeButton, setActiveButton] = useState("dataQuality");
  const theme = useTheme();

  const renderComponent = () => {
    switch (activeButton) {
      case "dataQuality":
        return <DataQuality />;
      case "validator":
        return <CsvValidator />;
      default:
        return null;
    }
  };

  return (
    <Box mt={16}>
      <Flex justify="center" mb={4}>
        <Stack direction="row" spacing={4}>
          <Button onClick={() => setActiveButton("dataQuality")} variant={activeButton === "dataQuality" ? "solid" : "outline"} borderColor={activeButton === "dataQuality" ? theme.colors.primary1 : "transparent"} borderWidth="2px">
            Data Quality
          </Button>
          <Button onClick={() => setActiveButton("validator")} variant={activeButton === "validator" ? "solid" : "outline"} borderColor={activeButton === "validator" ? theme.colors.primary1 : "transparent"} borderWidth="2px">
            CSV Validator
          </Button>
        </Stack>
      </Flex>
      <Flex justifyContent="left" ml={8}>
        <Box width="auto">{renderComponent()}</Box>
      </Flex>
    </Box>
  );
};

export default Validation;
